<template>
  <span class="badge-right mr-1 color" v-if="existing">
  </span>
</template>

<script>
import {mapState} from "vuex";

export default
{
  computed:
      {
        existing:function()
        {
          if(this.$store.state.hasOwnProperty('cartsave'))
          {
            if(this.$store.state.cartsave.hasOwnProperty('ids'))
            {
              if(this.$store.state.cartsave.ids.length > 0)
              {
                return true;
              }
              else
              {
                return false;
              }
            }
            else
            {
              return false;
            }
          }
          else
          {
            return false;
          }
        }
      }
}
</script>